const defaultMetaInfo = {
  metaTitle: 'Ambassador Portal',
  metaDescription: 'Spread the word about the brands you love. Get rewarded for being a brand ambassador.',
  faviconURL: '/images/favicon.png',
};

export default defaultMetaInfo;
